/**
 * Enum representing different support roles within the system.
 */
export enum SupportRole {
  /** Super Admin role with the highest level of access (value: 0). */
  SUPERADMIN = 0,

  /** Admin role with general administrative privileges (value: 1). */
  ADMIN = 1,

  /** Manager role with elevated permissions (value: 2). */
  MANAGER = 2,

  /** Support role with limited permissions for assistance tasks (value: 3). */
  SUPPORT = 3,
}